// Presentation-only wizard model for the IBAN request flow. All domain logic (response parsing,
// status derivation, draft persistence, fee-state and questionnaire rules) lives in
// `mmfintech-backend-api` and is shared across every brand portal — only the step model is local.

import { isOwnerOrAdministrator } from 'mmfintech-backend-api'

/**
 * Interactive steps of the flow. The Status screen is a terminal outcome, not a navigable step,
 * but it is shown as the final ("Done") node in the modal stepper.
 */
export const IbanStep = {
  SETUP: 1,
  QUESTIONNAIRE: 2,
  CONFIRM: 3,
  STATUS: 4
} as const

export type IbanStepValue = (typeof IbanStep)[keyof typeof IbanStep]

/**
 * Shared gate for every entry point into IBAN issuing (dashboard banner, Accounts page CTA, the
 * wizard's own self-guard) — keeps the three call sites from drifting if the eligibility rule
 * ever changes.
 */
export function isIbanIssuingEligible(
  customerRole: string | undefined,
  capabilities: { ibanEligible?: boolean } | undefined
): boolean {
  return isOwnerOrAdministrator(customerRole) && Boolean(capabilities?.ibanEligible)
}
